module.exports = __webpack_public_path__ + "img/16.8407ffa9.jpg";